module.exports = __webpack_public_path__ + "img/icons-settings-room.942b673.svg";